import {CanActivateFn, Router} from '@angular/router';
import {inject} from "@angular/core";
import {KeycloakService} from "../services/keycloak.service";
import {UserRole} from "../interfaces/api-interfaces";
import {ApiService} from "../services/api.service";
import {ViewModeService} from "../services/view-mode.service";

export const roleGuard: CanActivateFn = (route, state) => {
    const keycloakService = inject(KeycloakService);
    const router = inject(Router);
    const viewModeService = inject(ViewModeService);
    const user = keycloakService.currentUser();

    console.log('RoleGuard: Checking access to', state.url);
    console.log('RoleGuard: User:', user);

    // If no user data yet, don't redirect - let auth guard handle authentication
    if (!user) {
        console.log('RoleGuard: No user, blocking access');
        return false;
    }

    const allowedRoles = route.data['roles'] as string[];
    const foundRoles = user.roles.filter(role => allowedRoles.includes(role));

    console.log('RoleGuard: Required roles:', allowedRoles);
    console.log('RoleGuard: User roles:', user.roles);
    console.log('RoleGuard: Matching roles:', foundRoles);

    if (foundRoles.length > 0) {
        console.log('RoleGuard: Access granted');
        return true;
    }

    // User is authenticated but doesn't have required role
    // Redirect based on their actual roles (only if not already on target route)
    console.log('RoleGuard: Access denied, redirecting...');
    const isAdmin = user.roles.includes(UserRole.MASASANA) || user.roles.includes(UserRole.FREYMUT);
    const isDozent = user.roles.includes(UserRole.DOZENT);

    if (isAdmin) {
        let home: string;
        if (viewModeService.isTeilnehmerMode) home = '/home';
        else if (isDozent && viewModeService.isDozentMode) home = '/home';
        else home = '/teaching';
        if (state.url !== home) router.navigate([home]);
    } else if (isDozent) {
        if (state.url !== '/home') router.navigate(['/home']);
    } else if (user.roles.includes(UserRole.TEILNEHMER)) {
        if (state.url !== '/learning') router.navigate(['/learning']);
    }

    return false;
};
